<template>
  <span>
    <i v-if="loading" class="fa fa-spinner fa-spin"></i>{{ address }}
  </span>
</template>

<script>

export default {
  name: 'address-geocoder',
  data() {
    return {
      loading: false,
      address: '',
    }
  },
  props: ['fleetId', 'latitude', 'longitude'],
  created: function() {
    this.getData();
  },
  methods: {
    getData: function() {
      this.address = '';
      this.loading = true;
      this.$http.get('https://reversegeocoder.gtalarm.it/v1/lat/' + this.latitude + '/lng/' + this.longitude + '/lang/it')
        .then(response => {
          this.loading = false;
          this.address = response.data.results[0].formatted_address;
        });
    }
  },
  watch: {
    latitude: function(val) {
      if (val) {
        this.getData();
      }
    },
  }
}
</script>

<style scoped>
</style>
